export default __webpack_public_path__ + "static/media/linkedin-logo.7196ea10.svg";